//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import {
  GetSamplingCategoriesRequest,
  SamplingCategoriesResponse,
} from '@apis/campaign-requests/sampling/products/samplingCategoriesApiModel';
import { samplingV2Fetch } from '@apis/campaign-requests/sampling/samplingV2Fetch';
import { makeParams } from '@utils/makeParams';

/**
 * Get categories from catalog
 *
 * GET /api/v2/clients/products/categories
 */
export const getSamplingCategories = async (
  req: GetSamplingCategoriesRequest,
  init?: RequestInit,
): Promise<SamplingCategoriesResponse> => {
  const params = makeParams(req);

  const response = await samplingV2Fetch(`/products/categories?${params}`, {
    ...init,
    method: 'GET',
  });

  return response.json<SamplingCategoriesResponse>();
};
